export default __webpack_public_path__ + "static/media/Team_Leader_Role.5fec9668.svg";